import { logUsage } from 'owa-analytics';

export const LOCKED_APPS: string[] = ['Mail', 'Calendar'];

export function isInvalidAppBarPinnedAppsSetting(
    callerFn: string,
    appBarPinnedApps: string
): boolean {
    const splitIds = appBarPinnedApps.split(',');
    if (
        containsDuplicateIds(splitIds) ||
        splitIds.length < 2 ||
        splitIds[0] !== LOCKED_APPS[0] ||
        splitIds[1] !== LOCKED_APPS[1] ||
        appBarPinnedApps.includes('undefined') ||
        appBarPinnedApps.includes('true') ||
        appBarPinnedApps.includes('false')
    ) {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logUsage('AppBarPinnedApps_InvalidState', undefined, {
            caller: callerFn,
            value: appBarPinnedApps,
        });
        return true;
    }
    return false;
}

function containsDuplicateIds(splitIds: string[]) {
    const uniqueIds = new Set(splitIds);
    return splitIds.length !== uniqueIds.size;
}
